import { render, staticRenderFns } from "./EditGroupButtons.vue?vue&type=template&id=502b13f4"
import script from "./EditGroupButtons.vue?vue&type=script&lang=js"
export * from "./EditGroupButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports